// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CockpitNotificationStateLookupListResultModel from '../../model/cockpit-notification-state-lookup-list-result-model';
import CockpitNotificationStateLookupListResultDTO from '../dto/cockpit-notification-state-lookup-list-result-dto';
import dtoSchema from '../schemas/cockpit-notification-state-lookup-list-result-schema';
import CockpitNotificationStateLookupModel from '../../model/cockpit-notification-state-lookup-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class CockpitNotificationStateLookupListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CockpitNotificationStateLookupListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CockpitNotificationStateLookupModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: CockpitNotificationStateLookupModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<CockpitNotificationStateLookupListResultDTO>): CockpitNotificationStateLookupListResultModel;
  static toModel(dto: DeepPartial<CockpitNotificationStateLookupListResultDTO> | undefined | null): CockpitNotificationStateLookupListResultModel | undefined;
  static toModel(dto: DeepPartial<CockpitNotificationStateLookupListResultDTO> | undefined | null): CockpitNotificationStateLookupListResultModel | undefined {
    return dto ? new CockpitNotificationStateLookupListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CockpitNotificationStateLookupListResultModel> | CockpitNotificationStateLookupListResultModel): CockpitNotificationStateLookupListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as CockpitNotificationStateLookupListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CockpitNotificationStateLookupListResultModel, can not map to CockpitNotificationStateLookupListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
